module.exports = __webpack_public_path__ + "img/de_bg_6.ba95b325.jpeg";